import { __read } from "tslib";
import { useEffect, useRef, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
export function useResizeObserver(ref) {
    var isUnmount = useRef(null);
    var _a = __read(useState({}), 2), size = _a[0], setSize = _a[1];
    useEffect(function () {
        if (ref.current) {
            var resizeObserver_1 = new ResizeObserver(function (entries) {
                if (isUnmount.current || !Array.isArray(entries) || !entries.length) {
                    return;
                }
                var target = entries[0].target;
                var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
                setSize({ width: offsetWidth, height: offsetHeight });
            });
            resizeObserver_1.observe(ref.current);
            return function () {
                isUnmount.current = true;
                resizeObserver_1.disconnect();
            };
        }
        return function () { };
    }, [ref]);
    return size;
}
//# sourceMappingURL=use-resize-observer.js.map